const sourceOfChange = {
	createProductEditPage: 'Create Product - Edit Page',
	editProductEditPage: 'Edit Product - Edit Page',
	editSeller: 'Edit Seller',
	createSeller: 'Create Seller',
	createOrEditProduct: 'Create/Edit Product - Edit Page',
	editProductIsActiveToggle: 'Edit Product - Prodcut List - is Active toggle',
	createProductFromXLS: 'Create Product - From XLS',
	createVirtualSKUFromXLS: 'Create Virtual SKU - From XLS',
	createBillDataFromXLS: 'Create Billing Data - From XLS',
	createOrderFromXLS: 'Create Order - From XLS',
	linkProduct: 'Link Product - From Product List Actions',
	pullLabelBulkOrderList: 'Pull Label Bulk - Orders List',
	pullLabelOrderList: 'Pull Label - Orders List',
	pullLabelOrderDetails: 'Pull Label - Order Details',
	markAsShipped: 'Mark as Shipped - Order List',
	markAsShippedBulkOrderList: 'Mark as Shipped Bulk - Order List',
	createEditManualOrder: 'Create/Edit Manual Order',
	createCarrier: 'Create Carrier',
	updateCarrier: 'Update Carrier',
	createReturnAddress: 'Create Return Address',
	updateReturnAddress: 'Update Return Address',
	createChannel: 'Create Channel',
	updateChannel: 'Update Channel',
	updateChannelShouldSync: 'Update Channel - Should Sync Toggle - Channel List',
	channelListUpdatelWarehouseCodes: 'Update Channel - Warehouse Codes - Channel List',
	channelEditUpdateWarehouseCodes: 'Update Channel - Warehouse Codes - Channel Edit',
	sellerEditUpdateWarehouseManagements: 'Update Seller - Warehouse Managements - Seller Edit',
	updateSellerWarehousesList: 'Update Seller Warehouses - Seller List',
	updateSellerWarehousesEdit: 'Update Seller Warehouses - Seller Edit',
	sellerListUpdateWarehouseManagements: 'Update Seller - Warehouse Managements - Seller List',
	channelEditUpdateInventoryLog: 'Edit Channel - Update Inventory for Channel',
	productDetailUpdateInventoryLog: 'Product Detail - Update Inventory for Product',
	inventoryListUpdateInventoryLog: 'Inventory List - Update Inventory for All Channels and Products',
	authorizeAmazonSeller: 'Authorize Amazon SellerCentral',
	authorizeAmazonVendor: 'Authorize Amazon VendorCentral',
	updateBatchProductInventory: 'Update Batch ProductInventory - Product Details',
	createReceiving: 'Create Receiving',
	updateReceiving: 'Update Receiving',
	createProductCombination: 'Create Product Combination - Add Product part from Product Details',
	updateProductCombination: 'Create Product Combination - Edit Product part from Product Details',
	updateProduct: 'Update Product',
	createProduct: 'Create Product',
	createLookup: 'Create Lookup',
	editLookup: 'Edit Lookup',
	closeOutExitScan: 'Close Out Exit Scan - ',
	closeOutPalletizing: 'Close Out Palletizing -  Orders List',
	exitScanMode: 'Exit Scan',
	exitScanModeDetail: 'Exit Scan Detail',
	linkOrderLine: 'Link Order Line',
	linkAllOrderLines: 'Link All Order Lines',
	cancelAllOrderLines: 'Cancel All Order Lines',
	refundOrderLine: 'Refund Order Line',
	refundAllOrderLines: 'Refund All Order Lines',
	assignCarrierAndWarehouse: 'Assign Carrier and Warehouse',
	assignCarrierAndWarehouseBulk: 'Assign Carrier and Warehouse',
	splitOrder: 'Split Order - Order Details',
	splitOrderList: 'Split Order - Orders List',
	splitFullfilmentOrderLabelingMode: 'Split Fulfillment Order - Labeling Mode',
	syncAllChannelOrders: 'Sync All Channel Orders',
	syncSingleChannelOrdersMainMenu: 'Sync Single Channel Orders - Main menu - ',
	syncSingleChannelOrdersChannels: 'Sync Single Channel Orders - Channels section - ',
	onHoldBulkAction: 'On Hold Bulk - Orders List',
	onHoldAction: 'Update Order - On Hold - Orders List / Order Details',
	scanLabelLabelingMode: 'Scan Label - Labeling Mode - Find Fulfillment Order And Package',
	scanLabel: 'Scan Label - Labeling Mode',
	changeStatus: 'Change Status',
	replacementModal: 'Replacement Modal',
	undoPalletizeLabelingMode: 'Undo Palletize - Labeling Mode - Last action Palletize',
	undoPrintLabelLabelingMode: 'Undo - Labeling Mode - Last action Print Label',
	undoScanLabelLabelingMode: 'Undo - Labeling Mode - Last action Scan Label',
	abortLabelingMode: 'Abort - Labeling Mode',
	undoPalletizePalletizingMode: 'Undo Palletize - Palletizing Mode - Last action Palletizing',
	shipmentBulkPrintBulkList: 'Shipment Bulk - Print BulkList - Orders List',
	findFulfillmentOrderAndCreateLabelLabelingMode: 'Find Fulfillment Order And CreateLabel - Labeling Mode',
	undoPalletizeLabelingModeLastActionScan: 'Undo Palletize - Labeling Mode - Last action Scan Label',
	statusChange: 'Status Change - ',
	reasonChange: 'Reason Change - ',
	pickingBatchCreate: 'Picking Batch Create',
	productionModeOrderDetail: 'Production mode - Order Detail',
	findFulfillmentOrderAndPackageToExitScanLabelingMode:
		'Find Fulfillment Order And Package To Exit Scan - Labeling Mode',
	findShipmentInfoPalletizingMode: 'Find Shipment Info - Palletizing Mode',
	exitScanModeRemoveFromPallet: 'Exit Scan Mode - Remove From Pallet - Update Shipping Info',
	palletizingModeRemoveFromPallet: 'Palletizing Mode - Remove From Pallet - Update Shipping Info',
	palletizingModeCreatePallet: 'Palletizing Mode - Create pallet',
	palletizingModeUpdateShipmentInfoByTrackingNumber: 'Palletizing Mode - UpdateShipmentInfoByTrackingNumber',
	labelingModeRemoveFromPallet: 'Labeling Mode - Remove From Pallet - Update Shipping Info',
	labelingModeCreatePallet: 'Labeling Mode - Create Pallet',
	labelingModeUpdateShipmentInfoByTrackingNumber: 'Labeling Mode - labelingModeUpdateShipmentInfoByTrackingNumber',
	voidActiveLabelConfirmModalConfirm: 'Void Active Label - ConfirmModal- Confirmed',
	voidActiveLabelConfirmModalCancel: 'Void Active Label - ConfirmModal- Canceled',
	neverShipped: 'Never Shipped',
	changeShippingOrder: 'Change Shipping Order',
	voidActiveLabelConfirmModal: 'Void Active Label ConfirmModal',
	changeCarrier: 'Change Carrier',
	cancelFulfillmentOrder: 'Cancel Fulfillment Order - Order Details',
	cancelFulfillmentOrderList: 'Cancel Fulfillment Order - Orders List',
	createOrder: 'Create Order',
	updateOrder: 'Update Order',
	updateOrderInfo: 'Update Order Info',
	updateFulfillmentOrderInfo: 'Update FulfillmentOrder Info',
	voidLabel: 'Void Label',
	voidLabelBulk: 'Void Label Bulk',
	updateBuyShippingBulk: 'Update Buy Shipping - Bulk',
	inventorySync: 'Inventory Reconciliation',
	updatechannelInventory: 'Update Inventory for channel.',
	updateWarehouseOrganizationInfo: 'Update Warehouse Organization Info',
	voidLabelOption: {
		0: 'Void label Internaly',
		1: 'Void label on Channel',
		2: 'Transfer label to new warehouse',
		3: 'Do not void',
	},
	splitFulfillmentOrderSuperAdmin: 'Split Fulfillment Order by Super Admin',
	editFulfillmentOrderSplitSuperAdmin: 'Edit Fulfillment Order Split by Super Admin',
	bulk: 'Bulk',
	userPhoneCreated: 'User phone created',
	userPhoneUpdated: 'User phone updated',
	printBulkPrintHistoryItem: 'Print BulkPrintHistory Item',
	createBulkPrintHistoryItem: 'Create BulkPrintHistory Item',
	labelingModeCreateOrGetShipment: 'Create or get shipment - Labeling Mode',
	editWarehouse: 'Edit Warehouse',
	createWarehouse: 'Create Warehouse',
	isAvailableToggleWarehouseList: 'Is available - Toggle - Warehouses List',
	useAutoscanWarehouseList: 'Use Autoscan - Toggle - Warehouses List',
	acceptingReturns: 'Warehouse is  accepting return labels',
	printPackingSlipToggleSellerList: 'Print Packing Slip - Toggle - Seller List',
	partiallyFulfillMixedOrdersToggleSellerList: 'Partially Fulfill Mixed Orders - Toggle - Seller List',
	reoptimizeOrderList: 'Reoptimize Order - Orders List',
	reoptimizeOrderDetail: 'Reoptimize Order - Order Detail',
	reoptimizeOrderBulk: 'Reoptimize Order Bulk',
	createRestockDateChannel: 'Create restock date for channel',
	updateRestockDateChannel: 'Update restock date for channel',
	createRestockDateProduct: 'Create restock date for product',
	updateRestockDateProduct: 'Update restock date for product',
	customizeLabel: 'Customize Label',
};

export { sourceOfChange };



// WEBPACK FOOTER //
// ./src/common/constants/sourceOfChange.js